<template>
  <v-container>
    <v-layout column wrap>
      <v-flex>
        <v-flex class="text-center">
          <h3 class="display-2">{{ $t('select_branch') }}</h3>
        </v-flex>
        <v-expansion-panel v-model="selected_branches" expand multiple id="expansion-panel">
          <v-expansion-panel-content v-for="branch in branches" :key="branch.id" :disabled="!branch.online">
            <template v-slot:header>
              <v-layout column>
                <v-flex grow class="display-2">
                    <h3 class="ma-0">{{ stripHtml($t(branch.branch_name)) }}</h3>
                </v-flex>
                <v-flex grow class="subheading" v-if="!branch.online">
                  <v-icon color="red">sync_disabled</v-icon>
                  <span>{{ stripHtml($t('branch_offline')) }}</span>
                </v-flex>
              </v-layout>
            </template>
            <v-card v-if="branch.description != 0" class="subheading">
              <v-card-text v-html="$t(branch.name_desc)"></v-card-text>
              <v-card-actions>
                <v-flex>
                  <router-link :to="'/branch/' + branch.id">
                    <v-btn block color="info">{{ $t("take_appointment") }}</v-btn>
                  </router-link>
                  <router-link
                    :to="'/branch/' + branch.id + '/branchqueueinfo'"
                    v-if="globals.queueinfo && globals.queueinfo.split(',').includes('Strona oddziału')"
                  >
                    <v-btn block color="secondary my-1">{{ $t("branch_queueinfo") }}</v-btn>
                  </router-link>
                </v-flex>
              </v-card-actions>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <router-link to="/queueinfo" v-if="globals.queueinfo && globals.queueinfo.split(',').includes('Strona główna')">
          <v-btn block color="info">{{ $t("queueinfo") }}</v-btn>
        </router-link>
        <router-link to="/cancelall" v-if="globals.cancelallbutton && globals.cancelallbutton.split(',').includes('Strona główna')">
          <v-btn block color="secondary">{{ $t("withdrawconsent") }}</v-btn>
        </router-link>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import utilities from "../../mixins/utilities";

export default {
  mixins: [utilities],
  name: "rBranchesList",
  props: {
    branches: null,
    globals: null
  },
  data: function() {
    return {
      selected_branches: []
    };
  },
  created: function() {
    this.selected_branches = [];
  }
};
</script>

<style scoped>
.v-btn {
  height: auto;
  flex-flow: row wrap;
  padding: 0.5rem;
}

.v-btn /deep/ p {
  width: 100%;
  margin-bottom: 0.1rem;
}

.v-btn /deep/ span {
  width: 100%;
}

.v-btn{
  height: auto;
}

.v-btn /deep/ .v-btn__content{
  white-space: pre-line !important;
}

.v-btn:hover {
  text-decoration: none;
}
</style>